export default __webpack_public_path__ + "static/media/032-BBQ grill.cbb93206.svg";